import { Injectable } from '@angular/core';

import { DataProvider } from '../../providers/data/data';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../assets/vfs/vfs_fonts';
pdfMake.vfs = pdfFonts;

/*
  打印病例
  Generated class for the PrescriptionProvider provider.
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

/*
   Demo of params needed:

   'diagnose'     : 'Asthma',
   'phy_name'     : 'KELLY CHAIN YEUNG PUI KUEN',
   'notes_cons'   : this.notes.cons,
   'notes_disp'   : this.notes.disps,
   'notes_acus'   : this.notes.acus,
   'main_symptoms': this.mainSymptoms,
   'main_remarks' : this.mainRemarks,
   'p_symptoms'   : this.periodSymptoms,
   'p_remarks'    : this.periodRemarks,
   'symptoms'     : this.otherSymptoms,
   'remarks'      : this.otherRemarks,
   'explain'      : this.consultation[ 'con_explain' ],
   'dispensary'   : this.disp
*/

@Injectable()
export class ConsultationHistoryProvider
{

   public pdfObj = null;


   /** ----- Constructor ----- **/

   constructor(private data: DataProvider,) {}


   /** ----- Public Methods ----- **/

   create = ( inParams ) => {

      return new Promise<void>( resolve => {

         // modify dynamic content - date
         const dateStr = (inParams['createdate'] || '').split(' ')[0]

         // pack PDF content
         let content: any = [];
         content = [
            {
               table: {
                  widths: [ 20, 30, 5, '*', 5, 'auto', 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '姓名：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + inParams[ 'name' ], style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'BP：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + inParams[ 'bpRemarks' ], style: 'itemTitleTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ 20, 30, 5, '*', 5, 'auto', 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '日期：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + dateStr, style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'DX：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + inParams[ 'diagnose' ], style: 'itemTitleTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ '*' ],
                  body: [
                     [
                        { border: [ false, false, false, true ], text: '' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return 5; }
               }
            },
            {
               table: {
                  widths: [ 0, 'auto', '*', 5, 'auto', '*', 5, 'auto', '*', 5, 'auto', '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'C', style: 'itemTitleTC' },
                        { border: [ false, false, false, true ], text: '' + inParams[ 'notes_cons' ], style: 'itemCenterTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'M', style: 'itemTitleTC' },
                        { border: [ false, false, false, true ], text: '' + inParams[ 'notes_disp' ], style: 'itemCenterTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'A', style: 'itemTitleTC' },
                        { border: [ false, false, false, true ], text: '' + inParams[ 'notes_acus' ], style: 'itemCenterTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: 'Dr', style: 'itemTitleTC' },
                        { border: [ false, false, false, true ], text: '' + inParams[ 'con_phy' ], style: 'itemCenterTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return 5; },
                  paddingBottom  : function( i, node ) { return 2; }
               }
            },
            {
               table: {
                  widths: [ 60, 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '主訴：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + inParams[ 'main_remarks' ] == null? "-":inParams[ 'main_remarks' ], style: 'itemContentTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return 15; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ 60, 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '經期史：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '', style: 'itemContentTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ 60, 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '其他症狀：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '', style: 'itemContentTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ 60, 5, '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '補充及註解：', style: 'itemTitleTC' },
                        { border: [ false, false, false, false ], text: '' },
                        { border: [ false, false, false, false ], text: '' + ( inParams[ 'explain' ] != null ) ? inParams[ 'explain' ] : '', style: 'itemContentTC' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return null; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ '*' ],
                  body: [
                     [
                        { border: [ false, false, false, true ], text: '' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return 10; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            },
            {
               table: {
                  widths: [ '*' ],
                  body: [
                     [
                        { border: [ false, false, false, false ], text: '' }
                     ]
                  ]
               },
               layout: {
                  paddingLeft    : function( i, node ) { return null; },
                  paddingRight   : function( i, node ) { return null; },
                  paddingTop     : function( i, node ) { return 10; },
                  paddingBottom  : function( i, node ) { return null; }
               }
            }
         ];



         // dispensary content
         let count = 0;
         for ( let i = 0; i < inParams[ 'dispensary' ].length; i++ ) {
            if ( this.checkDisp( inParams[ 'dispensary' ][ i ] ) == true ) {
               /** Prescription **/
               if ( inParams[ 'dispensary' ][ i ][ 'data' ].length > 0 ) {
                  count++;

                  let dispObj = {
                     table: {
                        widths: [ 60, 5, '*' ],
                        body: []
                     },
                     layout: {
                        paddingLeft    : function( i, node ) { return null; },
                        paddingRight   : function( i, node ) { return null; },
                        paddingTop     : function( i, node ) { return null; },
                        paddingBottom  : function( i, node ) { return null; }
                     }
                  };

                  // loop each data in dispensary content
                  for ( let j = 0; j < inParams[ 'dispensary' ][ i ][ 'data' ].length; j++ )
                  {
                     console.log( 'i: ' + i + ', j: ' + j );
                     // get current dispensary object
                     let currentDispObj = inParams[ 'dispensary' ][ i ][ 'data' ][ j ];

                     // Dispensary - Single
                     if ( currentDispObj[ 'type' ] == 'disp-single' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        contentStr += currentDispObj['details'][ 'name_zh' ];
                        contentStr += '   ' + currentDispObj['details'][ 'default' ] + ' g';

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );
                     }
                     // Dispensary - Grouped
                     else if ( currentDispObj[ 'type' ] == 'disp-grouped' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        // contentStr += currentDispObj['details'][ 'name_zh' ];
                        contentStr += this.data.getDispGrpById(currentDispObj.details).name_zh;
                        contentStr += '   ' + currentDispObj[ 'default' ] + ' g';

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );


                        // creare a row and prepare string to be displayed
                        let detailsParam = [
                           { border: [ false, false, false, false ], text: '', style: 'itemContent' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let detailStr = '(';
                        for ( let k = 0; k < currentDispObj[ 'data' ].length; k++ )
                        {
                           // detailStr += currentDispObj[ 'data' ][ k ][ 'name_zh' ];
                           detailStr += this.data.getDispSingleById( currentDispObj[ 'data' ][ k ].id).name_zh;
                           if ( k < currentDispObj[ 'data' ].length - 1 ) detailStr += '，';
                        }
                        detailStr += ')';

                        // push one more column to table
                        detailsParam.push( {
                           border: [ false, false, false, false ],
                           text  : detailStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( detailsParam );
                     }
                     // Dispensary - Pills
                     else if ( currentDispObj[ 'type' ] == 'disp-pills' ) {
                        // creare a row and prepare string to be displayed
                        let param = [
                           { border: [ false, false, false, false ], text: '' + ( j == 0 ) ? ('處方' + ( i + 1 ) + '：') : '', style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        // contentStr += currentDispObj[ 'name_zh' ];
                        contentStr += this.data.getDispPillById(currentDispObj.details.id).name_zh;
                        // contentStr += '   ' + currentDispObj[ 'default' ] + ' g';
                        contentStr += '   ' + currentDispObj.details.default + ' g';

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );


                        // creare a row and prepare string to be displayed

                        // let detailsParam = [
                        //    { border: [ false, false, false, false ], text: '', style: 'itemContent' },
                        //    { border: [ false, false, false, false ], text: '' }
                        // ];
                        // let detailStr = '(';
                        // for ( let k = 0; k < currentDispObj[ 'data' ].length; k++ )
                        // {
                        //    detailStr += currentDispObj[ 'data' ][ k ][ 'item_name_zh' ];
                        //    if ( k < currentDispObj[ 'data' ].length - 1 ) detailStr += '，';
                        // }
                        // detailStr += ')';

                        // // push one more column to table
                        // detailsParam.push( {
                        //    border: [ false, false, false, false ],
                        //    text  : detailStr,
                        //    style : 'itemContentTC'
                        // } );
                        // dispObj[ 'table' ][ 'body' ].push( detailsParam );
                     }
                     // Dispensary - Internal
                     else if ( currentDispObj[ 'type' ] == 'disp-internal' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        contentStr += currentDispObj['details'][ 'name_zh' ];
                        contentStr += '   ' + currentDispObj['details'][ 'default' ];

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );
                     }
                     // Dispensary - External
                     else if ( currentDispObj[ 'type' ] == 'disp-external' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        contentStr += currentDispObj['details'][ 'name_zh' ];
                        contentStr += '   ' + currentDispObj['details'][ 'default' ];

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );
                     }
                     // Accupunture - Grouped
                     else if ( currentDispObj[ 'type' ] == 'acu-grouped' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        // contentStr += currentDispObj['details'][ 'name_zh' ];
                        contentStr += this.data.getAcuGrpById(currentDispObj['details']).name_zh;

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );


                        // creare a row and prepare string to be displayed
                        let detailsParam = [
                           { border: [ false, false, false, false ], text: '', style: 'itemContent' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let detailStr = '(';
                        for ( let k = 0; k < currentDispObj[ 'data' ].length; k++ )
                        {
                           detailStr += currentDispObj[ 'data' ][ k ][ 'item_name' ];
                           if ( k < currentDispObj[ 'data' ].length - 1 ) detailStr += '，';
                        }
                        detailStr += ')';

                        // push one more column to table
                        detailsParam.push( {
                           border: [ false, false, false, false ],
                           text  : detailStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( detailsParam );
                     }
                     // Accupunture - Single
                     else if ( currentDispObj[ 'type' ] == 'acu-single' ) {
                        // creare a row and prepare string to be displayed
                        let titleStr = ( j == 0 ) ? ( '處方' + ( i + 1 ) + '：' ) : '';
                        let param = [
                           { border: [ false, false, false, false ], text: titleStr, style: 'itemTitleTC' },
                           { border: [ false, false, false, false ], text: '' }
                        ];
                        let contentStr = '';
                        contentStr += '－ ';
                        contentStr += currentDispObj['details'][ 'name_zh' ];

                        // push one more column to table
                        param.push( {
                           border: [ false, false, false, false ],
                           text  : contentStr,
                           style : 'itemContentTC'
                        } );
                        dispObj[ 'table' ][ 'body' ].push( param );
                     }
                  }
                  content.push( dispObj );
               }

               console.log( 'usage case 1: ' );
               console.log( inParams[ 'dispensary' ][ i ][ 'usage' ] != null );
               /** Usage **/
               if ( inParams[ 'dispensary' ][ i ][ 'usage' ].length > 0 ) {
                  console.log( 'usage case' );
                  let usageObj = {
                     table: {
                        widths: [ 60, 5, '*' ],
                        body: []
                     },
                     layout: {
                        paddingLeft    : function( i, node ) { return null; },
                        paddingRight   : function( i, node ) { return null; },
                        paddingTop     : function( i, node ) { return null; },
                        paddingBottom  : function( i, node ) { return null; }
                     }
                  };

                  let param = [
                     { border: [ false, false, false, false ], text: '服用方法：', style: 'itemTitleTC' },
                     { border: [ false, false, false, false ], text: '' }
                  ];

                  // let usageStr = '' + count + '.';
                  let usageStr = '';
                  for ( let j = 0; j < inParams[ 'dispensary' ][ i ][ 'usage' ].length; j++ )
                  {
                     let usageObj = inParams[ 'dispensary' ][ i ][ 'usage' ][ j ];
                     if ( usageObj[ 'zh' ].indexOf( '(' ) > -1 && usageObj[ 'zh' ].indexOf( ')' ) > -1 )
                     {
                        let startIdx = usageObj[ 'zh' ].indexOf( '(' );
                        let endIdx = usageObj[ 'zh' ].indexOf( ')' ) + 2;
                        usageStr += usageObj[ 'zh' ].substring( 0, startIdx ) + usageObj[ 'default' ] + usageObj[ 'zh' ].substring( endIdx, usageObj[ 'zh' ].length );
                     }
                     else
                     {
                        usageStr += usageObj[ 'zh' ];
                     }
                  }
                  param.push( {
                     border: [ false, false, false, false ],
                     text: usageStr,
                     style: 'itemContentTC'
                  } );
                  usageObj[ 'table' ][ 'body' ].push( param );
                  content.push( usageObj );
               }

               content.push( {
                  table: {
                     widths: [ 75, 5, '*' ],
                     body: [
                        [
                           { border: [ false, false, false, false ], text: '' },
                        ]
                     ]
                  },
                  layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return 10; },
                     paddingBottom  : function( i, node ) { return 10; }
                  }
               } );
            }
         };

         // Signatures
         content.push( {

            table: {
               widths: [ '*', 'auto', 5, 70, 5, 'auto', 5, 70 ],
               body: [
                  [
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, false ], text: '針灸：', style: 'itemTitleTC' },
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, true ], text: '' + inParams[ 'acu_phy' ], style: 'itemContentTC' },
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, false ], text: '處方：', style: 'itemTitleTC' },
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, true ], text: '' + inParams[ 'disp_phy' ], style: 'itemContentTC' }
                  ]
               ]
            },
            layout: {
               paddingLeft    : function( i, node ) { return null; },
               paddingRight   : function( i, node ) { return null; },
               paddingTop     : function( i, node ) { return 10; },
               paddingBottom  : function( i, node ) { return null; }
            }
         } );


         // Signature - dispensary
         content.push( {

            table: {
               widths: [ '*', 'auto', 5, 70 ],
               body: [
                  [
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, false ], text: '配藥：', style: 'itemTitleTC' },
                     { border: [ false, false, false, false ], text: '' },
                     { border: [ false, false, false, true ], text: '' + inParams[ 'dispensings' ], style: 'itemContentTC' }
                  ]
               ]
            },
            layout: {
               paddingLeft    : function( i, node ) { return null; },
               paddingRight   : function( i, node ) { return null; },
               paddingTop     : function( i, node ) { return 10; },
               paddingBottom  : function( i, node ) { return null; }
            }
         } );


         // period_symptoms
         let periodSymptoms = '';
         for ( let i = 0; i < inParams[ 'p_symptoms' ].length; i++ )
         {
            periodSymptoms += inParams[ 'p_symptoms' ][ i ][ 'item_name_zh' ];
            if ( inParams[ 'p_remarks' ][ i ].length > 0 )
            {
               periodSymptoms += ' - ';
               periodSymptoms += inParams[ 'p_remarks' ][ i ];
            }
            if ( i < inParams[ 'p_symptoms' ].length - 1 ) periodSymptoms += '，';
         }
         content[ 5 ][ 'table' ][ 'body' ][ 0 ][ 2 ][ 'text' ] = periodSymptoms;


         console.log( 'sym' );
         // other_symptoms
         let otherSymptoms = '';
         for ( let i = 0; i < inParams[ 'symptoms' ].length; i++ )
         {
            otherSymptoms += inParams[ 'symptoms' ][ i ][ 'item_name_zh' ];
            if ( inParams[ 'remarks' ][ i ].length > 0 )
            {
               otherSymptoms += ' - ';
               otherSymptoms += inParams[ 'remarks' ][ i ];
            }
            if ( i < inParams[ 'symptoms' ].length - 1 ) otherSymptoms += '，';
         }
         content[ 6 ][ 'table' ][ 'body' ][ 0 ][ 2 ][ 'text' ] = otherSymptoms;

         console.log( 'done' );

         var docDefinition =
         {
            content: content,
            // footer: [
            //    {
            //       columns: [
            //          { width: '*', text: '' },
            //          { width: 'auto', text: inParams[ 'address_en' ] + " | ", style: 'footer' },
            //          { width: 'auto', text: " " + inParams[ 'address_zh' ], style: 'footerTC' },
            //          { width: '*', text: '' }
            //       ]
            //    },
            //    { text: "T: " + inParams[ 'tel' ] + " | F: " + inParams[ 'fax' ] + " | " + inParams[ 'url' ], style: 'footer' }
            // ],
            styles:
            {
               itemTitleTC: {
                  font: 'Arial-Unicode-MS',
                  bold: true,
                  fontSize: 10,
               },
               itemTitle: {

                  bold: true,
                  fontSize: 10
               },
               itemContentTC: {

                  font: 'Arial-Unicode-MS',
                  fontSize: 10,
               },
               itemContent: {

                  fontSize: 10
               },
               itemCenterTC: {

                  alignment: 'center',
                  font: 'Arial-Unicode-MS',
                  fontSize: 10,
               },
               itemCenter: {

                  fontSize: 10
               },
               itemContentRemark: {

                  margin: [ 0, 18, 0, 0 ],
                  fontSize: 10,
                  alignment: 'center'
               }
            },
            defaultStyle: {

               font: 'Arial-Unicode-MS'
            },
            pageSize: 'A5',
            pageOrientation: 'portrait',
            pageMargins: [ 20, 30 ],
         };

         // setup fonts
         pdfMake.fonts =
         {
            'Arial-Unicode-MS': {

               normal: 'Arial-Unicode-MS.ttf',
               bold: 'Arial-Unicode-MS.ttf'
            }
         };

         // create PDF file
         this.pdfObj = pdfMake.createPdf(docDefinition);
         console.log( 'function end' );
         resolve();
      });
   }

   checkDisp( inObj )
   {

      // for ( let i = 0; i < inObj[ 'data' ].length; i++ )
      // {
      //    console.log( inObj[ 'data' ][ i ][ 'type' ] );
      // //    if ( inObj[ 'data' ][ i ][ 'type' ] != 'disp-single' && inObj[ 'data' ][ i ][ 'type' ] != 'disp-grouped' && inObj[ 'data' ][ i ][ 'type' ] != 'disp-pills' )
      // //    {
      // //       return false;
      // //    }
      // }

      return true;

   }

}



// WEBPACK FOOTER //
// ./src/providers/cons-history/cons-history.ts